
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({})
export default class BgNavPageItem extends Vue {
  @Prop() name!: string;
  @Prop({ required: false, default: true }) open?: boolean;
  @Prop({ required: false, default: "" }) icon?: string;
  contentVisible = false;
  created(): void {
    this.contentVisible = !!this.open;
  }
  @Watch("open")
  handleOpenChange(val: boolean): void {
    this.contentVisible = !!val;
  }
  toggleShowContent(): void {
    this.contentVisible = !this.contentVisible;
    this.$emit("update:open", this.contentVisible);
    console.log(this.contentVisible);
  }
}
